function WaitLoader() {
    return <img src="/images/loading.gif"/>
}

export default WaitLoader;